
import { DataTable } from "./components/dataTable";
import { Navigation } from "./components/navigation";


function App() {
  return (
    <div className="App">
            <Navigation />
            <DataTable />
    </div>
  );
}

export default App;
